import { Component, Input, OnInit, OnDestroy, OnChanges, AfterViewInit, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { SiteDetailsModel } from 'src/app/models/SiteDetails/SiteDetailsModel';
import { SitePopupInfoModel } from 'src/app/models/SiteDetails/SitePopupInfoModel';
import { SiteWeatherForecastModel } from 'src/app/models/SiteDetails/SiteWeatherForecastModel';
import { FavouriteIconClickedEvent } from 'src/app/shared/favourite-icon/favourite-icon.component';


@Component({
	selector: 'app-favourite-site',
	templateUrl: './favourite-site.component.html',
	styleUrls: ['./favourite-site.component.scss']
})
export class FavouriteSiteComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
	@Input() siteDetails : SiteDetailsModel;
	@Output() removeFromFavourites : EventEmitter<string> = new EventEmitter<string>();

	constructor()
	{

	}
	ngOnInit() : void {

	}

	ngOnChanges(changes : SimpleChanges) {

	}

	ngOnDestroy(): void {
		
	}

	ngAfterViewInit(): void {
		
	}

	get siteImage(): string {    
		const img = this.siteDetails?.SitePhoto ?? "assets/images/SiteDetails/Default_img_web.png";
		return img;
	}
		
	get sitePopupInfo() {
		let weatherForecastModel;
		let sitePopupInfo : SitePopupInfoModel | undefined = undefined;
		if(this.siteDetails?.Identifier)
		{
			try
			{			
				const today = new Date();
				const year = today.getFullYear(), month = today.getMonth(), date = today.getDate();
				const todaysTimeStamp = new Date(year, month, date).getTime();	
	
				const weatherForToday = this.siteDetails?.WeatherForecast.find((w) => {
					let result = false;
					try
					{
						const forecastDateTime = new Date(Date.parse(w.ForecastDateTime?.toString()));
						if(forecastDateTime && "function" === typeof(forecastDateTime.getDate))
						{
							result = todaysTimeStamp === new Date(forecastDateTime?.getFullYear(), 
								forecastDateTime?.getMonth(), forecastDateTime?.getDate()).getTime();
						}						
					}
					catch(error : any)
					{
						console.log(error.message);
					}				
					return result;

				});
					
				if(weatherForToday)
				{
					weatherForecastModel = {
						...weatherForToday,
						FirstTideHighTime : null != weatherForToday?.FirstTideHighTime ? new Date(Date.parse(weatherForToday?.FirstTideHighTime)) : null,
						FirstTideLowTime : null != weatherForToday?.FirstTideLowTime ? new Date(Date.parse(weatherForToday?.FirstTideLowTime)) : null,
						NextTideHighTime : null != weatherForToday?.NextTideHighTime ? new Date(Date.parse(weatherForToday?.NextTideHighTime)) : null,
						NextTideLowTime : null != weatherForToday?.NextTideLowTime ? new Date(Date.parse(weatherForToday?.NextTideLowTime)) : null,
						SecondTideHighTime : null != weatherForToday?.SecondTideHighTime ? new Date(Date.parse(weatherForToday?.SecondTideHighTime)) : null,
						SecondTideLowTime : null != weatherForToday?.SecondTideLowTime ? new Date(Date.parse(weatherForToday?.SecondTideLowTime)) : null						
					}
					sitePopupInfo = <SitePopupInfoModel> (<unknown>{
						...this.siteDetails,
						LatestResultDate : this.siteDetails?.LatestResultDt,
						PollForecastDateTime : this.siteDetails?.PollForecastDt,
						WeatherForecast : weatherForecastModel
					});
				}
			}
			catch(ex : any) 
			{
				console.log(ex?.message);
			}
		}	
		
		return sitePopupInfo;
	}


	onFavouriteIconClicked = (event : FavouriteIconClickedEvent) => {
		if(event.siteIdentifier === this.siteDetails?.Identifier && !event.isFavourite)
		{
			this.removeFromFavourites.emit(this.siteDetails?.Identifier);
		}		
	}	
}
